
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("form/recurrency-hidden",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <input type=\"hidden\" name=\"recurrencyInterval\" value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"recurrencyInterval") : depth0), depth0))
    + "\"/><input type=\"hidden\" name=\"recurrency\" value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"recurrency") : depth0), depth0))
    + "\"/><input type=\"hidden\" name=\"byDay\" value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"byDay") : depth0), depth0))
    + "\"/><input type=\"hidden\" name=\"byMonthDay\" value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"byMonthDay") : depth0), depth0))
    + "\"/> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"recurrencyEndDate") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":293},"end":{"line":1,"column":420}}})) != null ? stack1 : "")
    + " ";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <input type=\"hidden\" name=\"recurrencyEndDate\" value=\""
    + container.escapeExpression(lookupProperty(helpers,"deltatime").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"recurrencyEndDate") : depth0),"iso",{"name":"deltatime","hash":{},"data":data,"loc":{"start":{"line":1,"column":372},"end":{"line":1,"column":409}}}))
    + "\"/> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  stack1 = ((helper = (helper = lookupProperty(helpers,"recurrencyDescriptor") || (depth0 != null ? lookupProperty(depth0,"recurrencyDescriptor") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"recurrencyDescriptor","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":446}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"recurrencyDescriptor")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { return stack1; }
  else { return ''; }
},"useData":true});
export default TPL;